import {
    createRestClient,
    RestClient,
} from '@superbet-group/web.lib.rest';

import { defaultHttpTimeoutMs } from '@core/constants';
import { getCmsUrl } from '@core/services/cms/utils';
import Bank from '@core/models/user/Bank';

export class BrazilBanksService {
    private readonly restClient: RestClient = createRestClient(
        getCmsUrl({
            path: '/brazil-banks/',
        }),
        defaultHttpTimeoutMs,
    );

    /**
     * @throws {Error}
     */
    public getBrazilBanks(): Promise<Bank[]> {
        return this.restClient.get(
            '',
        );
    }
}

export const brazilBanksService = new BrazilBanksService();
